export const FLOWCODE_TERMS_OF_USE_LINK = 'https://www.flowcode.com/terms-of-use'
export const FLOWCODE_PRIVACY_POLICY = 'https://www.flowcode.com/privacy-policy'
export const FLOWCODE_TRIALS_TERMS_OF_SERVICE = 'https://www.flowcode.com/trials-terms-of-service'
